import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './header.css'

const Header = (props) => {
  return (
    <div id={props.headerId} className="header-container1">
      <header data-thq="thq-navbar" className="header-navbar-interactive">
        <div data-thq="thq-navbar-nav" className="header-desktop-menu">
          <nav className="header-links1">
            <a
              href={props.textUrlAbout}
              rel="noreferrer noopener"
              className="header-about-l1"
            >
              {props.textAbout ?? (
                <Fragment>
                  <span className="header-text7">About</span>
                </Fragment>
              )}
            </a>
            <a
              href={props.textUrlProjects}
              rel="noreferrer noopener"
              className="header-projects-l1"
            >
              {props.textProjects ?? (
                <Fragment>
                  <span className="header-text6">Projects</span>
                </Fragment>
              )}
            </a>
            <a href="/" className="header-logo-link">
              <img
                alt={props.imageAlt1}
                src={props.imageSrcX2}
                className="header-image1"
              />
            </a>
            <a
              href={props.textUrlServices}
              rel="noreferrer noopener"
              className="header-services-l1"
            >
              {props.textServices ?? (
                <Fragment>
                  <span className="header-text1">Services</span>
                </Fragment>
              )}
            </a>
            <a
              href={props.textUrlContact}
              rel="noreferrer noopener"
              className="header-contact-l1"
            >
              {props.textContact ?? (
                <Fragment>
                  <span className="header-text8">Contact</span>
                </Fragment>
              )}
            </a>
          </nav>
        </div>
        <div data-thq="thq-burger-menu" className="header-burger-menu">
          <svg viewBox="0 0 1024 1024" className="header-icon1">
            <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
          </svg>
          {/* <div className="header-container2">
            <img
              alt={props.imageAltX}
              src={props.imageSrcX}
              className="header-image2"
            />

          </div> */}
          <div className="header-container2">
            <a href="/" className="header-logo-link">
              <img
                alt={props.imageAltX}
                src={props.imageSrcX}
                className="header-image2"
              />
            </a>
          </div>

        </div>
        <div data-thq="thq-mobile-menu" className="header-mobile-menu">
          <div className="header-nav">
            <div className="header-top">
              <img
                alt={props.logoAltMobile}
                src={props.logoSrcMobile}
                className="header-logo"
              />
              <div data-thq="thq-close-menu" className="header-close-menu">
                <svg viewBox="0 0 1024 1024" className="header-icon3">
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </div>
            </div>
            <nav className="header-links2">
              <a
                href={props.textUrlAbout}
                rel="noreferrer noopener"
                className="header-about-l2"
              >
                {props.textAboutMobile ?? (
                  <Fragment>
                    <span className="header-text4">About</span>
                  </Fragment>
                )}
              </a>
              <a
                href={props.textUrlProjects}
                rel="noreferrer noopener"
                className="header-projects-l2"
              >
                {props.textProjectsMobile ?? (
                  <Fragment>
                    <span className="header-text5">Projects</span>
                  </Fragment>
                )}
              </a>
              <a
                href={props.textUrlServices}
                rel="noreferrer noopener"
                className="header-services-l2"
              >
                {props.textServicesMobile ?? (
                  <Fragment>
                    <span className="header-text2">Services</span>
                  </Fragment>
                )}
              </a>
              <a
                href={props.textUrlContact}
                rel="noreferrer noopener"
                className="header-contact-l2"
              >
                {props.textContactMobile ?? (
                  <Fragment>
                    <span className="header-text3">Contact</span>
                  </Fragment>
                )}
              </a>
            </nav>
          </div>
        </div>
      </header>
    </div>
  )
}

Header.defaultProps = {
  logoAltMobile: 'image',
  textServices: undefined,
  textServicesMobile: undefined,
  textUrlContact: '/#contact',
  logoSrcMobile: '/logo_mobile-1500h.webp',
  textContactMobile: undefined,
  headerId: 'headerId',
  textUrlServices: '/#ServicesId',
  textUrlProjects: '/#ProjectsId',
  textAboutMobile: '/#AboutCompany',
  textProjectsMobile: '/#ProjectsId',
  imageSrcX2: '/logo_mobile-1500h.webp',
  textUrlAbout: '/#AboutCompany',
  textProjects: undefined,
  imageAltX: 'logo',
  imageSrcX: '/logo_mobile-1500h.webp',
  imageAlt1: 'logo',
  textAbout: '/#AboutCompany',
  textContact: undefined,
}

Header.propTypes = {
  logoAltMobile: PropTypes.string,
  textServices: PropTypes.element,
  textServicesMobile: PropTypes.element,
  textUrlContact: PropTypes.string,
  logoSrcMobile: PropTypes.string,
  textContactMobile: PropTypes.element,
  headerId: PropTypes.string,
  textUrlServices: PropTypes.string,
  textUrlProjects: PropTypes.string,
  textAboutMobile: PropTypes.element,
  textProjectsMobile: PropTypes.element,
  imageSrcX2: PropTypes.string,
  textUrlAbout: PropTypes.string,
  textProjects: PropTypes.element,
  imageAltX: PropTypes.string,
  imageSrcX: PropTypes.string,
  imageAlt1: PropTypes.string,
  textAbout: PropTypes.element,
  textContact: PropTypes.element,
}

export default Header
